// transactionSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TransactionDetails {
  receiver_id: string;
  recipient_user_code: string;
  recipient_user_name: string;
  requested_amount: string;
  confirmed_amount: string;
  note: string;
}

interface TransactionState {
  selectedTransaction: TransactionDetails | null;
}

const initialState: TransactionState = {
  selectedTransaction: null,
};

const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    setSelectedTransaction(state, action: PayloadAction<TransactionDetails>) {
      state.selectedTransaction = action.payload;
    },
    clearSelectedTransaction(state) {
      state.selectedTransaction = null;
    }
  },
});

export const { setSelectedTransaction, clearSelectedTransaction } = transactionSlice.actions;
export default transactionSlice.reducer;
